import { HawaPanel } from '../types'

import component from './hw.component.vue'
import editor from './hw.editor.vue'
// import { Attribute } from './types'

export default class HistoricalAlarm implements HawaPanel {
  name = 'HistoricalAlarm'
  title = 'Historical Alarm'
  component = component
  editor = editor
  snapshot = {
    DeletedAt: null,
    title: 'Historical Alarm',
    component: 'HistoricalAlarm',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 16, x: 16, y: 18 },
    attributes: {
      snapshot: true,
      background: '#d4a0a0',
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: true,
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '10px',
        padding: '4px',
        'text-align': 'left',
        width: '40%',
      },
      labelText: 'SO<sub>2</sub>',
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      tag: 'OSx7fzjZz',
      'title.show': false,
      unitStyle: {
        'background-color': '#ffffff',
        color: '#002feb',
        'font-size': '10px',
        padding: '4px',
        width: '20%',
      },
      unitText: 'ppm',
      updateInterval: 3000,
      valueMax: 39,
      valueMin: 20,
      valuePrecision: 2,
      valueStyle: {
        'background-color': '#050dff',
        color: '#ffffff',
        'font-size': '12px',
        'font-weight': '300',
        padding: '4px',
        'text-align': 'left',
        width: '40%',
      },
    },
  }

  init = {
    DeletedAt: null,
    title: 'Historical Alarm',
    component: 'HistoricalAlarm',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 160, x: 16, y: 18 },
    attributes: {
      snapshot: false,
      panelHeader: {
        show: false,
        style: {},
      },
      background: '#d4a0a0',
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: true,
      labelSource: 'tag.name',
      labelTextStyle: {
        'vertical-align': 'middle',
      },
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '30px',
        padding: '10px',
        'text-align': 'left',
        width: '40%',
      },
      labelText: 'default',
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      tag: 'OSx7fzjZz',
      'title.show': false,
      unitTextStyle: {
        'vertical-align': 'middle',
      },
      unitStyle: {
        'background-color': '#ffffff',
        color: '#002feb',
        'font-size': '30px',
        padding: '10px',
        width: '20%',
      },
      unitText: 'ppm',
      valueMax: 100000,
      valueMin: 0,
      valuePrecision: 4,
      valueTextStyle: {
        'vertical-align': 'middle',
      },
      valueStyle: {
        'background-color': '#050dff',
        color: '#ffffff',
        'font-size': '30px',
        'font-weight': '300',
        padding: '10px',
        'text-align': 'left',
        width: '40%',
      },
    },
  }
}
